import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import IncorrectPtAdmittedComponentsStep2Part1 from "./incorrect-pt-admitted-components-step2-parts/incorrect-pt-admitted-components-step2-part1";

export default class IncorrectPtAdmittedComponentsStep2Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: IncorrectPtAdmittedComponentsStep2ComponentMainConfig) {
		let context = this;
		context._parts.push(new IncorrectPtAdmittedComponentsStep2Part1(context.config.scenario, () => {
			context.config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface IncorrectPtAdmittedComponentsStep2ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: IncorrectPtAdmittedComponentsStep2ComponentPart1Config;
	onDone: () => void;
}

export interface IncorrectPtAdmittedComponentsStep2ComponentPart1Config extends GeneralPartConfig {
}